/** Тексты окна: Задания дня. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.tasks.title": "Daily tasks",
  "win.tasks.resets": "New tasks in {h}h {m}m",
  "win.tasks.kills": "Kill {n} zombies",
  "win.tasks.waves": "Clear {n} waves",
  "win.tasks.upgrades": "Upgrade {n} times",
  "win.tasks.bonus": "All three: bag of coins",
  "win.tasks.claim": "Claim",
  "win.tasks.close": "Close",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.tasks.title": "Задания дня",
  "win.tasks.resets": "Новые через {h} ч {m} мин",
  "win.tasks.kills": "Убей зомби: {n}",
  "win.tasks.waves": "Пройди волн: {n}",
  "win.tasks.upgrades": "Прокачай {n} раза",
  "win.tasks.bonus": "Все три: мешок монет",
  "win.tasks.claim": "Забрать",
  "win.tasks.close": "Закрыть",
};

const uk: Record<Key, string> = {
  "win.tasks.title": "Завдання дня",
  "win.tasks.resets": "Нові за {h} год {m} хв",
  "win.tasks.kills": "Убий зомбі: {n}",
  "win.tasks.waves": "Пройди хвиль: {n}",
  "win.tasks.upgrades": "Прокачай {n} рази",
  "win.tasks.bonus": "Усі три: мішок монет",
  "win.tasks.claim": "Забрати",
  "win.tasks.close": "Закрити",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
